// One brief tap pulse, independent of network latency and hover behavior.
(() => {
  if (window.nsCardFeedbackReady) return;
  window.nsCardFeedbackReady = true;
  const timers = new WeakMap();
  const flash = event => {
    const button = event.target.closest?.('.ns-card-actions .ns-bag-button, .ns-card-actions .card__link');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    clearTimeout(timers.get(button));
    button.classList.add('ns-tapped');
    timers.set(button, setTimeout(() => button.classList.remove('ns-tapped'), 180));
  };
  document.addEventListener('pointerdown', flash, {capture: true, passive: true});
  document.addEventListener('click', flash, {capture: true});
})();

(() => {
  const root = window.Shopify?.routes?.root || '/';
  const cartURL = window.routes?.cart_url || `${root}cart`;
  let toast, timer;
  function notify(message, error = false, pending = false) {
    if (!toast) {
      const style = document.createElement('style');
      style.textContent = `.ns-cart-notice{position:fixed;left:24px;right:auto;bottom:24px;z-index:10000;display:flex;align-items:center;gap:16px;max-width:420px;padding:18px 20px;border:1px solid #e4e4df;border-radius:12px;background:#fff;color:#191919;box-shadow:0 8px 35px #0002;font:400 13px/1.6 Axiforma,sans-serif;opacity:0;transform:translateY(12px);visibility:hidden;transition:opacity .1s,transform .1s,visibility .1s}.ns-cart-notice.is-visible{opacity:1;transform:none;visibility:visible}.ns-cart-notice[role=status]>span{white-space:nowrap}.ns-cart-notice a{color:inherit;text-decoration:underline;text-underline-offset:3px;white-space:nowrap}.ns-cart-notice button{background:none;border:0;color:inherit;padding:4px;font-size:22px;cursor:pointer}.ns-cart-notice[role=alert]{border-color:#b96060}@media(max-width:749px){.ns-cart-notice{left:50%;right:auto;bottom:calc(180px + env(safe-area-inset-bottom, 0px));width:max-content;max-width:calc(100vw - 28px);box-sizing:border-box;justify-content:center;gap:12px;padding:14px 16px;font-size:12px;transform:translate(-50%,12px)}}@media(max-width:749px){.ns-cart-notice.is-visible{transform:translate(-50%,0)}}@media(prefers-reduced-motion:reduce){.ns-cart-notice{transition:none}}`;
      document.head.append(style);
      toast = document.createElement('div');
      toast.className = 'ns-cart-notice';
      toast.setAttribute('aria-live', 'polite');
      toast.setAttribute('aria-atomic', 'true');
      toast.addEventListener('mouseenter', () => clearTimeout(timer));
      toast.addEventListener('focusin', () => clearTimeout(timer));
      const schedule = () => {clearTimeout(timer); timer = setTimeout(() => toast.classList.remove('is-visible'), 4000);};
      toast.addEventListener('mouseleave', schedule);
      toast.addEventListener('focusout', schedule);
      document.body.append(toast);
    }
    clearTimeout(timer);
    toast.replaceChildren();
    toast.setAttribute('role', error ? 'alert' : 'status');
    const copy = document.createElement('span');
    copy.textContent = message;
    toast.append(copy);
    if (!error && !pending) {
      const link = document.createElement('a');
      link.href = cartURL;
      link.textContent = 'View cart';
      toast.append(link);
    }
    const close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Dismiss notification');
    close.textContent = '×';
    close.addEventListener('click', () => {clearTimeout(timer);toast.classList.remove('is-visible');});
    toast.append(close);
    toast.classList.add('is-visible');
    if (!pending) timer = setTimeout(() => toast.classList.remove('is-visible'), error ? 6500 : 4000);
  }
  function cartSections() {
    const renderer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    let sections = [];
    try {sections = renderer?.getSectionsToRender?.() || [];} catch (_) {}
    return [...sections, {id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section'}];
  }
  function refreshCartSections(sections, requested) {
    if (!sections) return;
    requested.forEach(item => {
      const html = sections[item.section || item.id];
      if (!html) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const host = document.getElementById(item.id);
      if (!host) return;
      const selector = item.selector || '.shopify-section';
      const source = parsed.querySelector(selector);
      const target = host.matches(selector) ? host : host.querySelector(selector);
      if (source && target) target.innerHTML = source.innerHTML;
    });
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.remove('is-empty');
  }
  async function refreshHeaderCount(sequence) {
    const response = await fetch(`${root}cart.js`, {headers: {'Accept': 'application/json'}, credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) return;
    const cart = await response.json();
    if (sequence !== refreshSequence) return;
    if (!Number.isInteger(cart.item_count) || cart.item_count < 0) return;
    document.querySelectorAll('.natura-cart-mark .cart-count-bubble, .menu-drawer__utility-account-cart .cart-count-bubble').forEach(bubble => {
      let number = bubble.querySelector('span[aria-hidden="true"]');
      if (!number) {
        number = document.createElement('span');
        number.setAttribute('aria-hidden', 'true');
        bubble.prepend(number);
      }
      number.textContent = String(cart.item_count);
      bubble.classList.toggle('natura-cart-empty', cart.item_count === 0);
      bubble.hidden = cart.item_count === 0;
      const accessible = bubble.querySelector('.visually-hidden');
      if (accessible) accessible.textContent = `${cart.item_count} items in your cart`;
    });
  }
  let refreshSequence = 0;
  async function refreshCartUI(requested) {
    const sequence = ++refreshSequence;
    // Header count is fetched independently of the slower drawer HTML.
    void refreshHeaderCount(sequence).catch(() => {});
    const ids = [...new Set(requested.map(item => item.section || item.id).filter(Boolean))].slice(0, 5);
    if (!ids.length) return;
    try {
      const url = new URL(cartURL, window.location.href);
      url.searchParams.set('sections', ids.join(','));
      const response = await fetch(url.toString(), {headers: {'Accept': 'application/json'}, credentials: 'same-origin', cache: 'no-store'});
      if (!response.ok) return;
      const sections = await response.json();
      if (sequence === refreshSequence) refreshCartSections(sections, requested);
    } catch (_) {}
  }
  if (customElements.get('product-form')) return;
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      if (!this.form || !this.submitButton) return;
      const variantInput = this.form.querySelector('[name="id"]');
      if (variantInput && !this.submitButton.disabled) variantInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.hideErrors = this.dataset.hideErrors === 'true';
      // Adding a product displays a status message, not a dialog.
      this.submitButton.removeAttribute('aria-haspopup');
    }
    async onSubmitHandler(event) {
      event.preventDefault();
      if (!this.submitButton || this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.error = false;
      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.setAttribute('aria-busy', 'true');
      this.submitButton.classList.add('loading');
      const formData = new FormData(this.form);
      const requested = cartSections();
      notify('Adding to cart…', false, true);
      try {
        const response = await fetch(window.routes?.cart_add_url || `${root}cart/add.js`, {
          method: 'POST',
          headers: {'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body: formData
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          const message = result.description || result.message || 'Unable to add this product. Please try again.';
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: message, message: result.message});
          }
          this.handleErrorMessage(message);
          notify(message, true);
          return;
        }
        notify('Added to cart.');
        // Background rendering cannot delay the notification or the submit button.
        void refreshCartUI(requested);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          try {publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id'), cartData: result});} catch (_) {}
        }
      } catch (error) {
        const message = error.message || 'Unable to add this product. Please try again.';
        this.handleErrorMessage(message);
        notify(message, true);
      } finally {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.removeAttribute('aria-busy');
      }
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage && this.errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
})();

// Category grouping must include every page, otherwise one type is split between pages.
if (!customElements.get('ns-category-grid')) {
  customElements.define('ns-category-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.abort = new AbortController();
      this.setAttribute('aria-busy', 'true');
      this.groupProducts();
    }
    disconnectedCallback() { this.abort?.abort(); }
    async groupProducts() {
      const list = this.querySelector('#product-grid');
      if (!list) {this.setAttribute('data-ready', '');this.removeAttribute('aria-busy');return;}
      const originalPagination = this.querySelector('[data-original-pagination]');
      if (originalPagination) originalPagination.hidden = true;
      const size = Number(this.dataset.pageSize) || 24;
      const current = Number(this.dataset.page) || 1;
      const pageCount = Number(this.dataset.pages) || 1;
      const pages = new Map([[current, Array.from(list.children)]]);
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', this.dataset.section);
      const queue = Array.from({length: pageCount}, (_, i) => i + 1).filter(page => page !== current);
      try {
        const worker = async () => {
          while (queue.length) {
            const page = queue.shift();
            const pageURL = new URL(url);
            pageURL.searchParams.set('page', String(page));
            const response = await fetch(pageURL.toString(), {signal: this.abort.signal, credentials: 'same-origin'});
            if (!response.ok) throw new Error('Could not load collection page');
            const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
            const remoteList = parsed.querySelector('ns-category-grid #product-grid');
            if (!remoteList) throw new Error('Collection grid missing');
            pages.set(page, Array.from(remoteList.children));
          }
        };
        await Promise.all(Array.from({length: Math.min(3, queue.length)}, worker));
        if (!this.isConnected) return;
        const seen = new Set();
        this.products = Array.from(pages.keys()).sort((a, b) => a - b).flatMap(page => pages.get(page)).filter(card => {
          const id = card.dataset.productId;
          if (!id || seen.has(id)) return false;
          seen.add(id);
          return true;
        });
        const collator = new Intl.Collator(document.documentElement.lang || 'en', {sensitivity: 'base', numeric: true});
        const explicitSort = url.searchParams.has('sort_by');
        const normalize = value => value.trim().replace(/\s+/g, ' ').toLocaleLowerCase();
        const knownRoots = ['babies', 'body', 'face', 'gift sets', 'hair', 'men', 'oral care'];
        const menuLinks = Array.from(document.querySelectorAll('[data-natura-source] a[data-parent]')).map(link => {
          const path = new URL(link.href, window.location.href).pathname;
          const match = path.match(/\/collections\/([^/]+)/);
          return {label: link.textContent.trim(), parent: normalize(link.dataset.parent || ''), handle: match ? decodeURIComponent(match[1]) : ''};
        }).filter(link => link.handle);
        const categoryLinks = menuLinks.filter(link => link.parent === 'shop by categories');
        const rootLinks = categoryLinks.length
          ? categoryLinks.concat(menuLinks.filter(link => normalize(link.label) === 'gift sets'))
          : menuLinks.filter(link => knownRoots.includes(normalize(link.label)));
        const roots = rootLinks
          .filter((link, index, all) => all.findIndex(other => other.handle === link.handle) === index)
          .sort((a, b) => collator.compare(a.label, b.label));
        // Include descendant collections, so membership in a subcategory also identifies its parent.
        roots.forEach(root => {
          root.handles = new Set([root.handle]);
          const pending = [normalize(root.label)];
          const visited = new Set();
          while (pending.length) {
            const parent = pending.shift();
            if (visited.has(parent)) continue;
            visited.add(parent);
            menuLinks.filter(link => link.parent === parent).forEach(child => {
              root.handles.add(child.handle);
              pending.push(normalize(child.label));
            });
          }
        });
        this.products.forEach(card => {
          const handles = new Set((card.dataset.collectionHandles || '').split(',').filter(Boolean));
          // A product in several main categories is shown once, in the first alphabetic match.
          const root = roots.find(group => Array.from(group.handles).some(handle => handles.has(handle)));
          card.dataset.mainCategory = root ? root.label : '';
        });
        this.products.sort((a, b) => {
          const first = a.dataset.mainCategory || '';
          const second = b.dataset.mainCategory || '';
          if (!first && second) return 1;
          if (first && !second) return -1;
          return collator.compare(first, second)
            || collator.compare(a.dataset.category || '', b.dataset.category || '')
            || (explicitSort ? 0 : collator.compare(a.dataset.title || '', b.dataset.title || ''));
        });
        this.visibleCount = Math.min(size * current, this.products.length);
        if (originalPagination) originalPagination.remove();
        this.more = document.createElement('button');
        this.more.type = 'button';
        this.more.className = 'button ns-category-more';
        this.more.textContent = 'Load more';
        this.more.addEventListener('click', () => {
          this.visibleCount = Math.min(this.visibleCount + size, this.products.length);
          this.renderProducts(list);
        });
        this.append(this.more);
        this.renderProducts(list);
      } catch (error) {
        // Keep the original Shopify pagination and cards if any page request fails.
        if (originalPagination) originalPagination.hidden = false;
      } finally {
        // Reveal only the final order; failure reveals the original usable grid.
        this.setAttribute('data-ready', '');
        this.removeAttribute('aria-busy');
      }
    }
    renderProducts(list) {
      list.replaceChildren(...this.products.slice(0, this.visibleCount));
      this.more.hidden = this.visibleCount >= this.products.length;
    }
  });
}
